import {BaseEntity} from "./BaseEntity";

export class QueuedCommand implements BaseEntity {
    assetName:string;
    assetDescription:string;
    constructor(
        public id?:number,
        public vTagID?:string,
        public commandType?:string,
        public commandText?:string,
        public readerID?:number,
        public status:string = "Queued",
        public retryCount:string = "0",
        public lastAttempt?:string,
        public created?:string,
        public reason?: string,
        public amsName?: string) {
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.vTagID = json.vTagID;
        this.assetName = json.assetName;
        this.assetDescription = json.assetDescription;
        this.commandType = json.commandType;
        this.commandText = json.commandText;
        this.readerID = json.readerID;
        this.status = json.status;
        this.retryCount= json.retryCount;
        this.lastAttempt = json.lastAttempt;
        this.created = json.created;
        this.reason = json.reason;
        this.amsName = json.amsName;
    }
}
